// extracted by mini-css-extract-plugin
export var active = "_dv-7";
export var container = "_dv-0";
export var evenWidth = "_dv-4";
export var large = "_dv-5";
export var outlet = "_dv-8";
export var slide = "_dv-2";
export var small = "_dv-6";
export var tab = "_dv-3";
export var tabs = "_dv-1";